import _ from 'lodash';

import vb from '../definition';

import {
	unwrap,
} from '../util';


vb.filesArrayMinLength = (length, message) => {
	return {
		validator: v => {
			const min = unwrap(length);
			return !v
				|| !_.isArray(v)
				|| _.sumBy(v, f => {
					const file = unwrap(f);
					return Boolean(file);
				}) >= min;
		},
		message: () => {
			const min = unwrap(length);
			return message
				|| [
					`не менее ${min} ${min === 1 ? 'файла' : 'файлов'}`,
				];
		},
	};
};

vb.filesArrayMaxLength = (length, message) => {
	return {
		validator: v => {
			const max = unwrap(length);
			return !v
				|| !_.isArray(v)
				|| _.sumBy(v, f => {
					const file = unwrap(f);
					return Boolean(file);
				}) <= max;
		},
		message: () => {
			const max = unwrap(length);
			return message
				|| [
					`не более ${max} ${max === 1 ? 'файла' : 'файлов'}`,
				];
		},
	};
};